import getCoords from '../../utilities/function/getCoords';
const IntroHistoria = (props) => {
  const { introTexto, inicioHistoria } = props;
  return (
    <>
      <div className="lg:h-screen bg-rosado-claro xl:fondo-intro-historia xl:bg-transparent img-repeat-x py-24 lg:py-0">
        <div className="contenido h-full center ">
          <div className="w-11/12 lg:w-7/12 2xl:w-7/12 mx-auto">

            <div className=" max-h-500p scroll-rosado px-5">
              <p className="lato-700 text-24 text-center ">
                {introTexto()}
              </p>
            </div>

            <button
              className="poppins-700 text-18 mt-10 mx-auto text-rosado flex flex-col"
              onClick={() => {
               let topPosition = getCoords(inicioHistoria.current).top; 
               document.getElementsByTagName('html')[0].scrollTop = topPosition;           
             }} 
            >
              Seguir leyendo
              <span className="icon-abajo mt-2 text-24 block w-full"></span>
            </button>

          </div>
        </div>
      </div>

    </>
  )
}
export default IntroHistoria;